import { size, colors, Icons, typography } from '@everlywell/leaves';
import styled from 'styled-components';

export const Wrapper = styled.div`
  ${typography.subtitle};
  padding: ${size.md}px ${size.lg}px;
  background-color: ${colors.green1};
  display: flex;
  border-radius: ${size.xs1}px;
`;

export const Icon = styled(Icons.Information)`
  color: ${colors.teal4};
`;

export const IconWrapper = styled.div`
  max-width: ${size.lg}px;
  margin-right: ${size.md}px;
`;
